// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6nmbL{display:block;margin:0 0 24px;padding:0}._6nmbL table{border-collapse:collapse;font-family:Avenir,sans-serif;table-layout:fixed;width:100%}._6nmbL table td,._6nmbL table th{border:none;text-align:center}._6nmbL table th{color:#231f20;font-size:13px;font-weight:800;line-height:normal;vertical-align:top;width:56px}._6nmbL table th:nth-child(3){width:52px}._6nmbL table th:nth-child(5),._6nmbL table th:nth-child(6),._6nmbL table th:nth-child(7){width:80px}._6nmbL table td{color:#231f20;font-size:17px;font-weight:300;height:16px;line-height:normal;vertical-align:middle}._6nmbL table tr:nth-child(2n){background-color:#f2f2f2}", ""]);
// Exports
exports.locals = {
	"bloodGlucoseConcenctration__wrapper": "_6nmbL"
};
module.exports = exports;
